import React from 'react';

const index = (props) => {
  const { iconName, iconFrom, iconColor, togglePasswordVisibility, style } = props;

  let iconHeightWidth = iconFrom === 'kyc' ? '20' : '25';
  let iconMarginTop = iconFrom === 'kyc' ? '8px' : '23px';
  let iconColored =
    iconColor === 'selected' ? 'white' : iconColor === 'COMPLETE' ? '#21ce99' : '#e2603f';

  switch (iconName) {
    case 'basic':
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          viewBox="0 0 16 16"
          className="bi bi-person-fill"
        >
          <path
            style={{ fill: iconColored }}
            fillRule="evenodd"
            d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
          />
        </svg>
      );
    case 'address':
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          id="Layer_1"
          enableBackground="new 0 0 512 512"
          viewBox="0 0 512 512"
        >
          <g>
            <path
              style={{ fill: iconColored }}
              d="m407.579 87.677c-31.073-53.624-86.265-86.385-147.64-87.637-2.62-.054-5.257-.054-7.878 0-61.374 1.252-116.566 34.013-147.64 87.637-31.762 54.812-32.631 120.652-2.325 176.123l126.963 232.387c.057.103.114.206.173.308 5.586 9.709 15.593 15.505 26.77 15.505 11.176 0 21.183-5.797 26.768-15.505.059-.102.116-.205.173-.308l126.963-232.387c30.304-55.471 29.435-121.311-2.327-176.123zm-151.579 144.323c-39.701 0-72-32.299-72-72s32.299-72 72-72 72 32.299 72 72-32.298 72-72 72z"
            />
          </g>
        </svg>
      );
    case 'family':
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          viewBox="0 0 16 16"
          className="bi bi-people-fill"
        >
          <path
            style={{ fill: iconColored }}
            fillRule="evenodd"
            d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
          />
        </svg>
      );
    case 'occupation':
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          id="Capa_1"
          enableBackground="new 0 0 512 512"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path style={{ fill: iconColored }} d="m512 481.897h-31v-30h-450v30h-31v30h512z" />
            <path style={{ fill: iconColored }} d="m31 150.897h450v60h-450z" />
            <path style={{ fill: iconColored }} d="m61 240.897h90v181h-90z" />
            <path style={{ fill: iconColored }} d="m211 240.897h90v181h-90z" />
            <path style={{ fill: iconColored }} d="m361 240.897h90v181h-90z" />
            <path
              style={{ fill: iconColored }}
              d="m512 95.453-256-95.35-256 95.35v25.444h512zm-241-4.556h-30v-30h30z"
            />
          </g>
        </svg>
      );
    case 'occupation':
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          id="bold"
          enableBackground="new 0 0 24 24"
          viewBox="0 0 24 24"
        >
          <path
            style={{ fill: iconColored }}
            d="m13.03 1.87-10.99-1.67c-.51-.08-1.03.06-1.42.39-.39.34-.62.83-.62 1.34v21.07c0 .55.45 1 1 1h3.25v-5.25c0-.97.78-1.75 1.75-1.75h2.5c.97 0 1.75.78 1.75 1.75v5.25h4.25v-20.4c0-.86-.62-1.59-1.47-1.73zm-7.53 12.88h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm5 9h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
          <path
            style={{ fill: iconColored }}
            d="m22.62 10.842-7.12-1.491v14.649h6.75c.965 0 1.75-.785 1.75-1.75v-9.698c0-.826-.563-1.529-1.38-1.71zm-2.37 10.158h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
        </svg>
      );
    case 'documents':
      return (
        <svg
          // style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          version="1.1"
          id="Capa_1"
          viewBox="0 0 612 612"
        >
          <g id="_x33__9_">
            <g>
              <path
                style={{ fill: iconColored }}
                d="M535.5,95.625H420.75v-38.25c0-21.133-17.117-38.25-38.25-38.25h-153c-21.133,0-38.25,17.136-38.25,38.25v38.25H76.5
				c-42.247,0-76.5,34.253-76.5,76.5v95.625h612v-95.625C612,129.878,577.747,95.625,535.5,95.625z M382.5,95.625h-153V76.5
				c0-10.557,8.568-19.125,19.125-19.125h114.75c10.557,0,19.125,8.568,19.125,19.125V95.625z M382.5,325.125
				c0,42.247-34.253,76.5-76.5,76.5s-76.5-34.253-76.5-76.5c0-6.655,1.033-13.024,2.697-19.125H0v210.375
				c0,42.247,34.253,76.5,76.5,76.5h459c42.247,0,76.5-34.253,76.5-76.5V306H379.804C381.467,312.12,382.5,318.47,382.5,325.125z
				 M344.25,325.125c0-7-2.027-13.483-5.298-19.125h-65.885c-3.29,5.642-5.317,12.125-5.317,19.125
				c0,21.133,17.117,38.25,38.25,38.25C327.133,363.375,344.25,346.258,344.25,325.125z"
              />
            </g>
          </g>
        </svg>
      );
    case 'eye':
      return (
        <svg
          style={{ marginTop: iconMarginTop, ...style }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          onClick={togglePasswordVisibility}
        >
          <path d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z" />
        </svg>
      );
    case 'eye-slash':
      return (
        <svg
          style={{ marginTop: iconMarginTop, ...style }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          onClick={() => togglePasswordVisibility()}
        >
          <path d="M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z" />
        </svg>
      );
    case 'checked':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
          <path
            style={{ fill: '#228C22' }}
            d="M 19.28125 5.28125 L 9 15.5625 L 4.71875 11.28125 L 3.28125 12.71875 L 8.28125 17.71875 L 9 18.40625 L 9.71875 17.71875 L 20.71875 6.71875 Z"
          ></path>
        </svg>
      );
    case 'cross':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
          <path
            style={{ fill: '#c41719' }}
            d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"
          ></path>
        </svg>
      );

    case 'payment':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          version="1.1"
          id="Capa_1"
        >
          <path
            style={{ fill: iconColored }}
            d="M467.41,88.59c-0.674-3.525-4.069-5.837-7.605-5.163l-42.146,8.064c-11.53,2.212-21.351,9.398-26.949,19.729l-0.194,0.362
		c-11.818,21.783-28.697,40.974-48.814,55.499c-6.849,4.946-13.351,10.483-19.326,16.457l-60.944,60.937
		c-7.711,5.854-18.597,5.133-25.47-1.74c-3.665-3.665-5.684-8.54-5.684-13.726c0-5.193,2.019-10.071,5.684-13.736l44.022-44.023
		c14.996-14.995,18.445-38.141,8.387-56.285c-8.266-14.91-23.963-24.172-40.966-24.172c-0.918,0-5.224,0.227-5.224,0.227
		c-11.391,0.711-22.112,5.55-30.188,13.626l-28.461,28.461c-6.746,6.745-10.606,15.712-10.869,25.249l-0.544,19.758l-29.168,29.168
		l3.268-80.271c0.113-2.885,1.281-5.616,3.293-7.69l94.112-97.15c5.622-5.604,13.09-8.689,21.035-8.689h113.539
		c3.59,0,6.5-2.91,6.5-6.5s-2.91-6.5-6.5-6.5H264.657c-11.434,0-22.182,4.451-30.263,12.532c-0.024,0.024-0.049,0.049-0.073,0.074
		l-94.146,97.187c-4.243,4.375-6.711,10.139-6.948,16.22l-3.841,94.351L1.904,348.327C0.685,349.546,0,351.199,0,352.923
		s0.685,3.377,1.904,4.596l107.623,107.623c1.269,1.269,2.933,1.904,4.596,1.904s3.327-0.635,4.596-1.904L339.92,243.941
		c2.539-2.539,2.539-6.654,0-9.192l-25.187-25.187l16.833-16.831c5.487-5.486,11.458-10.57,17.745-15.111
		c21.688-15.66,39.888-36.352,52.64-59.856l0.196-0.364c3.727-6.876,10.273-11.667,17.958-13.141l42.144-8.063
		C465.773,95.521,468.085,92.116,467.41,88.59z M226.768,206.08c-6.121,6.121-9.491,14.263-9.491,22.929
		c0,8.659,3.371,16.798,9.491,22.918c6.29,6.29,14.594,9.493,22.936,9.493c7.059,0,14.145-2.294,20.056-6.953
		c0.201-0.158,0.392-0.328,0.573-0.509l18.733-18.731l7.791,7.791L117.795,422.078l-72.832-72.832l179.061-179.061l19.32,19.319
		L226.768,206.08z M221.184,113.837c5.835-5.834,13.579-9.331,21.788-9.843c0,0,3.764-0.202,4.432-0.202
		c12.28,0,23.62,6.696,29.597,17.475c7.261,13.1,4.708,29.873-6.21,40.79l-1.781,1.781l-36.712-36.711
		c-2.538-2.538-6.654-2.538-9.192,0l-12.725,12.725l0-15.21L221.184,113.837z M185.657,158.714c0.171-6.2,2.68-12.03,7.066-16.415
		l4.657-4.657v15.209l-11.889,11.889L185.657,158.714z M326.132,239.345L114.123,451.353l-98.431-98.43l212.009-212.009
		l32.116,32.115l-7.282,7.282l-23.915-23.916c-2.538-2.538-6.654-2.538-9.192,0L31.174,344.649c-2.539,2.539-2.539,6.654,0,9.192
		l82.024,82.024c1.269,1.269,2.933,1.904,4.596,1.904s3.327-0.635,4.596-1.904l188.252-188.253c2.539-2.539,2.539-6.654,0.001-9.192
		l-12.386-12.387l7.282-7.281L326.132,239.345z"
          />
          <path
            style={{ fill: iconColored }}
            d="M192.243,274.803c-18.173-18.173-41.779-23.039-53.74-11.078s-7.095,35.566,11.078,53.74
		c11.455,11.455,25.067,17.623,36.562,17.622c6.742,0,12.757-2.123,17.179-6.544c6.146-6.146,8.063-15.431,5.399-26.144
		C206.347,292.855,200.495,283.055,192.243,274.803z M194.129,319.351c-5.741,5.742-21.674,2.604-35.355-11.078
		c-13.682-13.682-16.819-29.614-11.078-35.355c1.803-1.803,4.611-2.73,8.04-2.73c7.487,0,17.931,4.424,27.316,13.809
		c6.51,6.51,11.268,14.361,13.054,21.541C197.603,311.561,196.883,316.597,194.129,319.351z"
          />
        </svg>
      );
    default:
      return (
        <svg
          style={{ marginTop: iconMarginTop }}
          width={iconHeightWidth}
          height={iconHeightWidth}
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
        >
          <g>
            <path
              style={{ fill: iconColored }}
              d="M501.362,383.95L320.497,51.474c-29.059-48.921-99.896-48.986-128.994,0L10.647,383.95
			c-29.706,49.989,6.259,113.291,64.482,113.291h361.736C495.039,497.241,531.068,433.99,501.362,383.95z M256,437.241
			c-16.538,0-30-13.462-30-30c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30C286,423.779,272.538,437.241,256,437.241z
			 M286,317.241c0,16.538-13.462,30-30,30c-16.538,0-30-13.462-30-30v-150c0-16.538,13.462-30,30-30c16.538,0,30,13.462,30,30
			V317.241z"
            />
          </g>
        </svg>
      );
  }
};

export default index;
